import type { ApiResponse, MentionIntelligenceResponse } from '@fluenceur/types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

const fetchMentionIntelligence = async (
  mentionId: string
): Promise<MentionIntelligenceResponse> => {
  const response = await api.get<ApiResponse<MentionIntelligenceResponse>>(
    `/dashboard/mentions/${mentionId}/intelligence`
  );
  return response.data.data as MentionIntelligenceResponse;
};

interface UseMentionIntelligenceQueryOptions {
  mentionId: string | null | undefined;
  enabled?: boolean;
}

export const useMentionIntelligenceQuery = ({
  mentionId,
  enabled = true,
}: UseMentionIntelligenceQueryOptions): UseQueryResult<MentionIntelligenceResponse, Error> => {
  return useQuery<MentionIntelligenceResponse, Error>({
    queryKey: ['mention-intelligence', mentionId],
    queryFn: () => {
      if (!mentionId) {
        return Promise.reject(new Error('Mention ID is required.'));
      }
      return fetchMentionIntelligence(mentionId);
    },
    enabled: !!mentionId && enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
  });
};

export { fetchMentionIntelligence };
